export enum ETipoTransacao {
	credito = "Crédito",
	debito = "Débito",
}